import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import * as _ from 'lodash';

declare var $: any;

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css']
})
export class EventComponent implements OnInit {

  public items: FirebaseListObservable<any>;
  public story_card_list: boolean[] = [];
  public audio: any[] = [
    { 'title': '中山醫學大學附設醫院', 'subtitle': '皮膚科主治醫師 賴柏如醫師', 'src': './assets/file/Hit FM廣播專訪-中山醫賴柏如醫師.mp3' },
    { 'title': ' 臺北榮民總醫院', 'subtitle': '皮膚診斷科主任 陳志強醫師', 'src': './assets/file/寶島北榮陳志強醫師.mp3' }
  ];
  public audio_now: number = 10000;

  constructor(db: AngularFireDatabase) {
    this.items = db.list('event');
  }

  ngOnInit() {


  }

  fn_btn_prev() {
    this.audio_now--;
  }

  fn_btn_next() {
    this.audio_now++;
  }

}



// WEBPACK FOOTER //
// ./src/app/event/event.component.ts